import * as React from "react";
import { ChevronDown, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TransformYourSpace() {
  const benefits = [{
    text: "Certified Master Shingle Applicators"
  }, {
    text: "Lifetime Workmanship Warranty"
  }, {
    text: "24/7 Emergency Roof Support"
  }];
  return <section data-section-id="221448" id="superior-exterior-protection" className="dark relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/modern_roofed_home_exterior.png')] bg-cover bg-center bg-no-repeat md:pb-14">
      <div className="absolute inset-0 bg-black/60" />

      <div className="relative z-10 flex w-full max-w-7xl flex-col items-center justify-center px-4 text-center">
        <div className="mb-6 flex items-center gap-2 bg-black/40 px-4 py-2 backdrop-blur-sm rounded-lg">
          <span className="font-default text-sm font-semibold uppercase tracking-widest text-white">
            5-Star Rated on Google
          </span>
        </div>
            <h3 className="font-default mb-4 w-full max-w-full break-words font-bold leading-[0.9] tracking-tighter text-white drop-shadow-2xl text-[46px] sm:text-[58px] md:text-[88px] lg:text-[128px] xl:text-[168px]">Protecting What Matters Most—Your Home.</h3>

        <div className="mb-8 inline-flex items-center rounded-lg bg-secondary/20 px-4 py-1.5 text-sm font-semibold text-secondary ring-1 ring-inset ring-secondary/30">
          Trusted by Local Homeowners | Licensed & Insured
        </div>

        <div className="mb-10 max-w-2xl">
          <p className="font-default mb-6 text-xl font-medium text-white/80 md:text-2xl">We install high-quality roofing systems engineered for Maryland's weather and backed by honest craftsmanship. Serving Montgomery County, Howard County, and Northern Virginia with dependable roofing and exterior services.</p>
         {}
        </div>
        <div className="flex flex-col items-center gap-3 w-full px-2 md:flex-row md:items-end md:w-auto md:px-0">
          <Button asChild size="lg" className="group relative h-auto w-full max-w-[420px] justify-center overflow-hidden rounded-lg bg-primary px-5 py-4 text-center font-default text-lg font-bold uppercase tracking-wider text-primary-foreground shadow-md transition-all duration-300 hover:-translate-y-1 hover:scale-105 hover:bg-primary/90 whitespace-normal md:w-auto md:max-w-none md:px-14 md:py-8 md:text-2xl md:whitespace-nowrap">
            <Link to="/ContactPage">
              <span className="relative z-10">Schedule Free Roof Inspection</span>
              <div className="absolute inset-0 -z-0 h-full w-full scale-x-0 bg-white/10 opacity-0 transition-all duration-500 group-hover:scale-x-100 group-hover:opacity-100" style={{
              transformOrigin: 'left center'
            }} />
            </Link>
          </Button>
         
          <div className="flex flex-col items-center gap-2 w-full md:w-auto">
  
            <Button asChild variant="outline" size="lg" className="group relative h-auto w-full max-w-[420px] justify-center overflow-hidden rounded-lg border-2 border-white bg-transparent px-5 py-4 text-center font-default text-lg font-bold uppercase tracking-wider text-white shadow-md transition-all duration-300 hover:-translate-y-1 hover:scale-105 hover:bg-white hover:text-black whitespace-normal md:w-auto md:max-w-none md:px-14 md:py-8 md:text-2xl md:whitespace-nowrap">
  <Link to="tel:2408991278">
    <span className="relative z-10">Call Now</span>
  </Link>
</Button>
           
          </div>

        </div>
      </div>
 
   
    </section>;
}